/* import __COLOCATED_TEMPLATE__ from './scim-group-membership-change-details.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type AppAdminEvent from 'embercom/models/app-admin-event';
import type AppService from 'embercom/services/app-service';

interface ScimGroupMembershipChangeDetailsSignature {
  Args: {
    event: AppAdminEvent;
  };
}

export default class ScimGroupMembershipChangeDetails extends Component<ScimGroupMembershipChangeDetailsSignature> {
  @service declare appService: AppService;
  @tracked showModal = false;

  @action
  toggleModal() {
    this.showModal = !this.showModal;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TableCells::AdminEvents::ScimGroupMembershipChangeDetails': typeof ScimGroupMembershipChangeDetails;
  }
}
